import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-dark-card relative overflow-hidden" data-id="element-246" data-mp="1d0cpnrg32dfu">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-247" data-mp="1rqbirfss6yog"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-248" data-mp="1mtbe99bky3zg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-249" data-mp="z25yeu5n3bp5">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-250" data-mp="17zq4cgeg5w63">
            <span className="text-2xl" data-id="element-251" data-mp="2jgy8d0l6la9q">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-252" data-mp="2jjaxpyt9qmwt">
            The most complete yoga teaching library for yoga teachers worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-253" data-mp="2buxg1889gj9v">
            Yoga Teacher Ready™
          </h3>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-254" data-mp="2gt8tdsxrlbwu">
            120 Ready-to-Teach Classes · 5 Strategic Bonuses · Everything ready
            to use from today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-255" data-mp="2ptdy1vbkpw7b">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-dark-border" data-id="element-256" data-mp="1t68ymw8zkw2u">
            <div className="flex items-start gap-3" data-id="element-257" data-mp="19h8avbduisd2">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-258" data-mp="19gp5eu5dtwfx" />
              <p className="text-gray-400 text-sm" data-id="element-259" data-mp="1efjlhobyt6wc">
                This is not a collection of random poses pulled from the
                internet.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-260" data-mp="2csdz12fs7zk0">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-261" data-mp="2crvxbqacot4p" />
              <p className="text-gray-400 text-sm" data-id="element-262" data-mp="2qihhdibjj946">
                This is not a theory book you need to rewrite before it works in
                a real class.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-263" data-mp="1yted42jnlyrj">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-264" data-mp="1yu7mlb9zz2dd" />
              <p className="text-gray-400 text-sm" data-id="element-265" data-mp="1tuur62528mz6">
                This is not content designed for a different type of teacher
                that you have to adapt completely.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-266" data-mp="3j87ym08gyr4i">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-267" data-mp="3qt24vpqrikul"></div>
            <div className="flex items-start gap-3 relative z-10" data-id="element-268" data-mp="3ctslkh79fame">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-269" data-mp="3hs3vst1gvn55" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-270" data-mp="9bhju9dmn8l9">
                This is a complete professional teaching library — so you walk
                into every single class fully prepared, confident, and ready to
                deliver a session your students will feel.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}